import axios from "axios"
export function getAdvertiserCampaigns(token, advertiserId) {
    return axios.get(process.env.REACT_APP_API_URL + `/getCampaigns?advertiserId=${advertiserId}`, {
        headers: {
            'Authorization': `${token}`
        }
    });
}